import { render } from "./SFReport.vue?vue&type=template&id=2db5a975"
import script from "./SFReport.vue?vue&type=script&lang=js"
export * from "./SFReport.vue?vue&type=script&lang=js"

import "./SFReport.vue?vue&type=style&index=0&id=2db5a975&lang=css"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__